"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["checked", "children", "className", "custom", "defaultChecked", "disabled", "icon", "iconLabelPosition", "iconSize", "inline", "inputRef", "label", "name", "onChange", "onClick", "right", "tabIndex", "value"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RadioButtonIcon = function RadioButtonIcon(props) {
  var icon = props.icon,
    iconSize = props.iconSize,
    iconLabelPosition = props.iconLabelPosition,
    text = props.text;
  var iconStyles = {
    width: "".concat(iconSize, "px"),
    height: "".concat(iconSize, "px"),
    fontSize: "".concat(iconSize, "px"),
    lineHeight: "".concat(iconSize, "px")
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "radio-icon label-".concat(iconLabelPosition)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph ".concat(icon),
    style: iconStyles
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'radio-label'
  }, text));
};
var RadioButton = function RadioButton(props) {
  var checked = props.checked,
    children = props.children,
    className = props.className,
    custom = props.custom,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    icon = props.icon,
    iconLabelPosition = props.iconLabelPosition,
    iconSize = props.iconSize,
    inline = props.inline,
    inputRef = props.inputRef,
    label = props.label,
    name = props.name,
    onChange = props.onChange,
    onClick = props.onClick,
    right = props.right,
    tabIndex = props.tabIndex,
    value = props.value,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var labelRef = (0, _react.useRef)();
  var handleToggleKeyDown = function handleToggleKeyDown(event) {
    switch (event.keyCode) {
      case 32:
        // toggle on space
        toggle(event);
        break;
      case 13:
        // open on enter
        toggle(event);
        break;
      default:
        break;
    }
  };
  var toggle = function toggle(event) {
    event.preventDefault();
    if (disabled) {
      return;
    }

    // Controlled case - uses "onChange()" instead of "onClick()" callback
    if (checked !== null && checked !== undefined) {
      onChange(event);
      return;
    }

    // Uncontrolled case - set the input checked or unchecked
    labelRef.current.firstChild.checked = !labelRef.current.firstChild.checked;
    onClick(event);
  };
  var text = label || children;
  var labelClassnames = (0, _classnames["default"])('radio', inline && 'radio-inline', className);
  var inputClassnames = (0, _classnames["default"])(right && 'icon-right', className);
  var renderCustomIcon = !!icon;
  var renderCustomContent = custom && children;
  var renderDefault = !icon && !custom;
  return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({}, remainingProps, {
    className: labelClassnames,
    tabIndex: tabIndex,
    onKeyDown: handleToggleKeyDown,
    ref: labelRef
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: 'radio',
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    className: inputClassnames,
    ref: inputRef,
    onClick: onClick,
    onChange: onChange,
    name: name,
    value: value
  }), renderCustomIcon && /*#__PURE__*/_react["default"].createElement(RadioButtonIcon, {
    icon: icon,
    iconSize: iconSize,
    iconLabelPosition: iconLabelPosition,
    text: text
  }), renderDefault && /*#__PURE__*/_react["default"].createElement("span", {
    className: 'radio-text'
  }, /*#__PURE__*/_react["default"].createElement("span", null, text)), renderCustomContent && children);
};
RadioButton.ICON_LABEL_VERTICAL = 'vertical';
RadioButton.ICON_LABEL_HORIZONTAL = 'horizontal';
RadioButton.defaultProps = {
  inline: false,
  disabled: false,
  right: false,
  custom: false,
  tabIndex: 0,
  icon: '',
  iconSize: 16,
  iconLabelPosition: RadioButton.ICON_LABEL_VERTICAL,
  onClick: function onClick() {}
};
RadioButton.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  icon: _propTypes["default"].string,
  iconSize: _propTypes["default"].number,
  iconLabelPosition: _propTypes["default"].oneOf([RadioButton.ICON_LABEL_VERTICAL, RadioButton.ICON_LABEL_HORIZONTAL]),
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  defaultChecked: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  inline: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  custom: _propTypes["default"].bool,
  inputRef: _propTypes["default"].func,
  tabIndex: _propTypes["default"].number
};
var _default = RadioButton;
exports["default"] = _default;